import { gql } from "gql";

export const SAVE_DYNAMIC_ATTRIBUTE_GROUP = gql(/* GraphQL */ `
  mutation SaveDynamicAttributeGroup($group: DynamicAttributeGroupInput) {
    saveDynamicAttributeGroup(group: $group)
  }
`);
